import { gql } from 'apollo-boost';

export const GET_ADMIN_AUDIO_TRANSCRIPTION_DEBUG = gql`
    query GetAdminAudioTranscriptionDebug($data: GetAdminAudioTranscriptionDebugInput) {
        getAdminAudioTranscriptionDebug(data: $data) {
            providerUsage {
                from to days groupByUser
                rows {userId userLabel source provider model operations durationSeconds estimatedCostUsd unknownCostOperations unknownDurationOperations failedOperations unfinishedOperations}
            }
            usage {
                from to days groupByUser
                rows {userId userLabel source provider model operations durationSeconds estimatedCostUsd unknownCostOperations unknownDurationOperations}
            }
            filters {
                limit
                status
                userId
                messageId
                requestId
                staleOnly
            }
            summary {
                total
                pending
                processing
                completed
                failed
                staleProcessing
                retryableFailed
                recent24h
                completed24h
                failed24h
                averageAttempts
                totalActualDurationSeconds
                averageActualDurationSeconds
                totalEstimatedDurationSeconds
                statusCounts {
                    value
                    count
                }
                providerCounts {
                    value
                    count
                }
                outputFormatCounts {
                    value
                    count
                }
                queueKindCounts {
                    value
                    count
                }
            }
            jobs {
                id
                requestId
                messageId
                userId
                sourceUrl
                links { label url }
                queueKind
                provider
                groqModel
                outputFormat
                language
                languages
                detectedLanguages
                translateToEnglish
                sourceFileName
                sourceFileSize
                sourceDurationSeconds
                estimatedDurationSeconds
                actualDurationSeconds
                segmentCount
                transcriptCharacterCount
                status
                attempts
                dueAt
                nextRetryAt
                lockedUntil
                startedAt
                completedAt
                errorMessage
                createdAt
                updatedAt
                ageSeconds
                lockedSeconds
            }
        }
    }
`;
